import { Component, OnDestroy, OnInit } from '@angular/core';
import { InventoryStockTakeDto } from 'src/api/generated/models/Digiwork/MaitreD/Pos/DTO/InventoryStockTake/inventory-stock-take-dto';
import { EmployeeService, InventoryService } from 'src/api/generated/services';
import { GetInventoryStockItems$Params } from 'src/api/generated/fn/inventory/get-inventory-stock-items';
import { CurrentVenueHelperService } from 'src/app/share-modul/services/current-venue-helper/current-venue.helper.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ListAllEmployeesForVenue$Params } from 'src/api/generated/fn/employee/list-all-employees-for-venue';
import { AuthenticationService } from 'src/app/share-modul/services/authentication/authentication.service';
import { Subject, Subscription } from 'rxjs';
import { AddInventoryStockTake$Params } from 'src/api/generated/fn/inventory/add-inventory-stock-take';
import { AddStockTakeDto } from 'src/api/generated/models/Digiwork/MaitreD/Pos/DTO/InventoryStockTake/add-stock-take-dto';
import { ConfirmationService, MessageService } from 'primeng/api';
import { TranslateService } from '@ngx-translate/core';
import { StockTakeLineItemDto } from 'src/api/generated/models/Digiwork/MaitreD/Pos/DTO/InventoryStockTakeLineItems/stock-take-line-item-dto';
import { EmployeeDto } from 'src/api/generated/models/Digiwork/MaitreD/Pos/DTO/Employee/employee-dto';
import { AbstractControl, FormBuilder, FormControl, FormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { Location } from '@angular/common';
import { InventoryDto } from 'src/api/generated/models/Digiwork/MaitreD/Pos/DTO/Inventory/inventory-dto';
import { GetInventory$Params } from 'src/api/generated/fn/inventory/get-inventory';
import { RoleNameEnum } from 'src/app/admin-panel/enums/role-name.enum';
import { UserDto } from 'src/api/generated/models/Digiwork/MaitreD/Pos/DTO/User/user-dto';
import { ListManagerEmployeesForVenue$Params } from 'src/api/generated/fn/employee/list-manager-employees-for-venue';

@Component({
  selector: 'app-new-stock-take',
  templateUrl: './new-stock-take.component.html',
  styleUrls: ['./new-stock-take.component.scss']
})
export class NewStockTakeComponent implements OnInit, OnDestroy {

  inventoryId: string;
  inventory: InventoryDto;
  venueId: string;
  userId: string | undefined;

  unsubscribe: Subject<void> = new Subject<void>();
  stockTake: InventoryStockTakeDto = {} as InventoryStockTakeDto;
  assignedTo: EmployeeDto;
  stockItems: Array<StockTakeLineItemDto> = new Array<StockTakeLineItemDto>;
  employees: Array<EmployeeDto>;
  venueIdUpdateSubscription: Subscription;
  form: FormGroup;

  constructor(public location: Location,
              private inventoryService: InventoryService,
              private employeeService: EmployeeService,
              private currentVenueHelper: CurrentVenueHelperService,
              private authenticationService: AuthenticationService,
              private route: ActivatedRoute,
              public router: Router,
              private confirmationService: ConfirmationService, 
              private formBuilder: FormBuilder,
              public translate: TranslateService,
              private messageService: MessageService) {
              
    this.authenticationService.loginUser.subscribe(user => {
        this.authenticationService.getProfile(user?.roles).subscribe(response => this.stockTake.issuedByUser = response);
    });

    this.form = this.formBuilder.group({
      items: new FormControl([], [this.atLeastOneChecked]),
      assignedTo: new FormControl('', {
        validators: [Validators.required]
      })
    }); 
    
    this.route.params.subscribe(params => {
      if (params['venue-id'] != null) {
        this.venueId = params['venue-id'];
        this.currentVenueHelper.updateCurrentVenueIdDropdown(params['venue-id']);
        this.authenticationService.loginUser.subscribe(user => {
          if(user?.roles.includes(RoleNameEnum.PosManager)){
            const params: ListAllEmployeesForVenue$Params = { VenueId: this.venueId }
            this.employeeService.listAllEmployeesForVenue(params).subscribe( response => {
              this.employees = response;
            });
          }else{
            let companyId = this.authenticationService.getCompanyId();
            const params: ListManagerEmployeesForVenue$Params = { VenueId: this.venueId, CompanyId: companyId };
            this.employeeService.listAllEmployeesForVenue_1(params).subscribe( response => this.employees = response);
          }
      });
      }

      if (params['inventory-id'] != null) {
        this.inventoryId = params['inventory-id'];
        const p: GetInventoryStockItems$Params = { inventoryId: this.inventoryId };

        this.inventoryService.getInventoryStockItems(p).subscribe(response =>  {
          this.stockItems = response.stockItems ? response.stockItems?.map(element => {
             return { item: element.stockItem, quantityExpected: element.quantity} as StockTakeLineItemDto }) : [];
        });

        const invetoryParams: GetInventory$Params = { inventoryId: this.inventoryId };
        this.inventoryService.getInventory(invetoryParams).subscribe(response => this.inventory = response);
      }
    });
        
  }

  onSelect(event: any){
    this.form.controls['items'].setValue([...this.form.controls['items'].value, event.data]);
  }
  onUnselect(event: any){
    this.form.controls['items'].setValue([...this.form.controls['items'].value.filter((i: any) => i.item.id != event.data.item.id)]);
  }

  ngOnInit(): void {
  }

  issueStockTake(){
    if(this.form.valid){
      this.confirmationService.confirm({
        header: this.translate.instant('STOCK_TAKE.CONFIRMATION_DIALOG_ISSUE_STOCK_TAKE_TITLE'),
        message: this.translate.instant('STOCK_TAKE.CONFIRMATION_DIALOG_ISSUE_STOCK_TAKE_QUESTION'),
        acceptLabel: this.translate.instant('YES'),
        rejectLabel: this.translate.instant('NO'),
        defaultFocus: "reject",
        acceptButtonStyleClass: 'soc-confirmation-dialog dialog-btn constructive-btn',
        rejectButtonStyleClass: 'soc-confirmation-dialog dialog-btn reject-btn',
        accept: () => {
          const rawForm = this.form.getRawValue();
          const stockTakeToAdd: AddStockTakeDto = { assignedTo: rawForm.assignedTo, lineItems: rawForm.items };
          const p: AddInventoryStockTake$Params = { inventoryId: this.inventoryId, body: stockTakeToAdd };
          this.inventoryService.addInventoryStockTake(p).subscribe({
            next: response => {
              this.messageService.add( { severity: 'success', summary: 'Stock take was successfully issued!', life: 3000 } );
              this.navigateToMain();
            },
            error: errorResponse => this.messageService.add( { severity: 'error', summary: 'Error occurred!', life: 3000 } )
          });
        }
      });
  }
  }

  navigateToMain(){
    if(this.inventory.isMain){
     this.router.navigate([this.venueId, "inventory", this.inventoryId], { queryParams: { activeIndex: 4 }}); 
    } else {
      this.router.navigate([this.venueId, "inventory", this.inventoryId], { queryParams: { activeIndex: 3 }}); 
    }
  }

  atLeastOneChecked(control: AbstractControl) {
    const controlValue = control.value as Array<any>;
  
    if(controlValue.length != 0){
      return null;
    }
    return { atLeastOne: true }
  }

  public ngOnDestroy(): void {
    if (this.venueIdUpdateSubscription) {
      this.venueIdUpdateSubscription.unsubscribe();
    }
  }

}
